// import { createContext, useContext, useState } from "react";

// const CaptchaContext = createContext();
// const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const CaptchaProvider = ({ children }) => {
//   const [captchaToken, setCaptchaToken] = useState(null);
//   const [captchaVerified, setCaptchaVerified] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const verifyCaptcha = async (token) => {
//     try {
//       setLoading(true);

//       const res = await fetch(`${BASE_URL}/api/verify-captcha`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           token: token,
//         }),
//       });

//       const data = await res.json();

//       if (data.success) {
//         setCaptchaVerified(true);
//       } else {
//         setCaptchaVerified(false);
//       }

//       return data;
//     } catch (error) {
//       console.error("Captcha verify error:", error);
//       setCaptchaVerified(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <CaptchaContext.Provider
//       value={{
//         captchaToken,
//         setCaptchaToken,
//         captchaVerified,
//         verifyCaptcha,
//         loading,
//       }}
//     >
//       {children}
//     </CaptchaContext.Provider>
//   );
// };

// export const useCaptcha = () => useContext(CaptchaContext);
import { createContext, useContext, useState } from "react";
import axios from "axios";

const CaptchaContext = createContext();

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const CaptchaProvider = ({ children }) => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const verifyCaptcha = async (token) => {
    try {
      setLoading(true);

      const res = await axios.post(`${BASE_URL}/api/verify-captcha`, {
        token: token,
      });

      const data = res.data;

      if (data.success) {
        setCaptchaVerified(true);
      } else {
        setCaptchaVerified(false);
      }

      return data;
    } catch (error) {
      console.error(
        "Captcha verify error:",
        error?.response?.data || error.message,
      );
      setCaptchaVerified(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CaptchaContext.Provider
      value={{
        captchaToken,
        setCaptchaToken,
        captchaVerified,
        verifyCaptcha,
        loading,
      }}
    >
      {children}
    </CaptchaContext.Provider>
  );
};

export const useCaptcha = () => useContext(CaptchaContext);
